import styled from 'styled-components';

interface StyledButtonProps {
    $disabled?: boolean;
}
// TODO: add this variant to Button component.
export const StyledDefaultGroupButton = styled.button<StyledButtonProps>`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: -0.02em;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    gap: 7px;
    color: white;
    height: 40px;
    border: 1px solid rgba(18, 8, 40, 0.1);
    border-radius: 100px;
    background: linear-gradient(85deg, rgba(18, 8, 40, 0.85), rgba(18, 8, 40, 1)),
        linear-gradient(
            323deg,
            rgba(255, 255, 255, 0.4),
            rgba(255, 255, 255, 0.08),
            rgba(255, 255, 255, 0.08),
            rgba(255, 255, 255, 0.24),
            rgba(255, 255, 255, 0.08),
            rgba(255, 255, 255, 0.08),
            rgba(255, 255, 255, 0.4)
        );
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;

    &:disabled {
        cursor: not-allowed;
    }
`;
